module.exports = "<h1>{{data.title}}</h1>\n<p>{{data.description}}</p>\n<button align=\"end\" color=\"accent\" (click)=\"close()\">Annuler</button>"